export default function NoRouteErrorPage() {

  return (
    <div id="error-page">
      <h1>Błąd</h1>
      <p>Taka ścieżka w nie istnieje w aplikacji.</p>
    </div>
  );
}
